// extracted by mini-css-extract-plugin
module.exports = {"container":"_23OxI","extraMarginTop":"AvYaL","badge":"_1ebK1","date":"krH7Z","extraMarginLeft":"_3MsRq","badgeNoBackground":"_1HfSu","time":"_2XUWP"};